export function SparklesIcon(_ref) {
  var createElement = _ref.createElement;
  return createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M10 1.875c.27 0 .51.173.594.43l1.593 4.844a1.043 1.043 0 0 0 .664.664l4.844 1.593a.625.625 0 0 1 0 1.188l-4.844 1.593a1.043 1.043 0 0 0-.664.664l-1.593 4.844a.625.625 0 0 1-1.188 0l-1.593-4.844a1.042 1.042 0 0 0-.664-.664l-4.844-1.593a.625.625 0 0 1 0-1.188l4.844-1.593a1.042 1.042 0 0 0 .664-.664l1.593-4.844a.625.625 0 0 1 .594-.43ZM9 7.539A2.292 2.292 0 0 1 7.54 9L4.5 10l3.04 1A2.292 2.292 0 0 1 9 12.46l1 3.04 1-3.04A2.293 2.293 0 0 1 12.46 11l3.04-1-3.04-1A2.292 2.292 0 0 1 11 7.54L10 4.5 9 7.54ZM4.167 1.875c.345 0 .625.28.625.625v3.333a.625.625 0 0 1-1.25 0V2.5c0-.345.28-.625.625-.625ZM15.833 13.542c.345 0 .625.28.625.625V17.5a.625.625 0 1 1-1.25 0v-3.333c0-.345.28-.625.625-.625Z",
    clipRule: "evenodd"
  }), createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M1.875 4.167c0-.346.28-.625.625-.625h3.333a.625.625 0 1 1 0 1.25H2.5a.625.625 0 0 1-.625-.625ZM13.542 15.833c0-.345.28-.625.625-.625H17.5a.625.625 0 0 1 0 1.25h-3.333a.625.625 0 0 1-.625-.625Z",
    clipRule: "evenodd"
  }));
}
export function ArrowUpIcon(_ref2) {
  var createElement = _ref2.createElement;
  return createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, createElement("path", {
    d: "m5 12 7-7 7 7"
  }), createElement("path", {
    d: "M12 19V5"
  }));
}
export function ArrowRightIcon(_ref3) {
  var createElement = _ref3.createElement;
  return createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, createElement("path", {
    d: "M5 12h14"
  }), createElement("path", {
    d: "m12 5 7 7-7 7"
  }));
}
export function ChevronUpIcon(_ref4) {
  var createElement = _ref4.createElement;
  return createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, createElement("path", {
    d: "m18 15-6-6-6 6"
  }));
}
export function ChevronDownIcon(_ref5) {
  var createElement = _ref5.createElement;
  return createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, createElement("path", {
    d: "m6 9 6 6 6-6"
  }));
}
export function CloseIcon(_ref6) {
  var createElement = _ref6.createElement;
  return createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, createElement("path", {
    d: "M18 6 6 18"
  }), createElement("path", {
    d: "m6 6 12 12"
  }));
}
export function MaximizeIcon(_ref7) {
  var createElement = _ref7.createElement;
  return createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, createElement("path", {
    d: "M15 3h6v6"
  }), createElement("path", {
    d: "m21 3-7 7"
  }), createElement("path", {
    d: "m3 21 7-7"
  }), createElement("path", {
    d: "M9 21H3v-6"
  }));
}
export function MinimizeIcon(_ref8) {
  var createElement = _ref8.createElement;
  return createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, createElement("path", {
    d: "m14 10 7-7"
  }), createElement("path", {
    d: "M20 10h-6V4"
  }), createElement("path", {
    d: "m3 21 7-7"
  }), createElement("path", {
    d: "M4 14h6v6"
  }));
}
export function StopIcon(_ref9) {
  var createElement = _ref9.createElement;
  return createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, createElement("circle", {
    cx: "12",
    cy: "12",
    r: "10"
  }), createElement("rect", {
    x: "9",
    y: "9",
    width: "6",
    height: "6",
    rx: "1"
  }));
}
export function ReloadIcon(_ref0) {
  var createElement = _ref0.createElement;
  return createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, createElement("path", {
    d: "M3 12a9 9 0 0 1 9-9 9.75 9.75 0 0 1 6.74 2.74L21 8"
  }), createElement("path", {
    d: "M21 3v5h-5"
  }), createElement("path", {
    d: "M21 12a9 9 0 0 1-9 9 9.75 9.75 0 0 1-6.74-2.74L3 16"
  }), createElement("path", {
    d: "M3 21v-5h5"
  }));
}
export function CopyIcon(_ref1) {
  var createElement = _ref1.createElement;
  return createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, createElement("rect", {
    width: "14",
    height: "14",
    x: "8",
    y: "8",
    rx: "2",
    ry: "2"
  }), createElement("path", {
    d: "M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2"
  }));
}
export function MenuIcon(_ref10) {
  var createElement = _ref10.createElement;
  return createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, createElement("circle", {
    cx: "12",
    cy: "12",
    r: "1"
  }), createElement("circle", {
    cx: "12",
    cy: "5",
    r: "1"
  }), createElement("circle", {
    cx: "12",
    cy: "19",
    r: "1"
  }));
}
export function LoadingSpinnerIcon(_ref11) {
  var createElement = _ref11.createElement;
  return createElement("svg", {
    viewBox: "12 12 24 24",
    role: "status",
    "aria-busy": "true",
    "aria-live": "polite"
  }, createElement("title", null, "Loading spinner"), createElement("circle", {
    cx: "24",
    cy: "24",
    r: "11",
    fill: "none",
    stroke: "currentColor"
  }));
}
export function ChevronLeftIcon(_ref12) {
  var createElement = _ref12.createElement;
  return createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, createElement("path", {
    d: "m15 18-6-6 6-6"
  }));
}
export function ChevronRightIcon(_ref13) {
  var createElement = _ref13.createElement;
  return createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, createElement("path", {
    d: "m9 18 6-6-6-6"
  }));
}